import { FilterTypes } from '@carboledger/ui';
import { buildActivityModuleFilterOptions } from './activityModules';
import {
  ACTIVITY_DATE_PRESETS,
  ACTIVITY_FILTERS,
  LAST_ACTIVE_PRESETS,
  USER_FILTERS,
} from './admin.constants';
import { buildRoleFilterOptions } from './userRoles';

// Filter panels for the Access manager and the Activity log.

export const buildUserFilterDefinitions = (t) => [
  {
    field: USER_FILTERS.accessType,
    label: t('FIELD_ACCESS_TYPE'),
    type: FilterTypes.checkbox,
    options: buildRoleFilterOptions(t),
  },
  {
    field: USER_FILTERS.lastActive,
    label: t('FIELD_LAST_ACTIVE'),
    type: FilterTypes.dateRange,
    presets: [
      { value: LAST_ACTIVE_PRESETS.today, label: t('FILTER_TODAY') },
      { value: LAST_ACTIVE_PRESETS.yesterday, label: t('FILTER_YESTERDAY') },
    ],
    rangeLabel: t('FILTER_SELECT_RANGE'),
  },
];

export const buildActivityFilterDefinitions = (t, userOptions) => [
  {
    field: ACTIVITY_FILTERS.user,
    label: t('FIELD_USER'),
    type: FilterTypes.checkbox,
    options: userOptions,
  },
  {
    field: ACTIVITY_FILTERS.activityDate,
    label: t('FIELD_ACTIVITY_DATE'),
    type: FilterTypes.dateRange,
    presets: [
      { value: ACTIVITY_DATE_PRESETS.today, label: t('FILTER_TODAY') },
      { value: ACTIVITY_DATE_PRESETS.yesterday, label: t('FILTER_YESTERDAY') },
      { value: ACTIVITY_DATE_PRESETS.last3, label: t('FILTER_LAST_3_DAYS') },
      { value: ACTIVITY_DATE_PRESETS.last7, label: t('FILTER_LAST_7_DAYS') },
      { value: ACTIVITY_DATE_PRESETS.last30, label: t('FILTER_LAST_30_DAYS') },
      { value: ACTIVITY_DATE_PRESETS.last60, label: t('FILTER_LAST_60_DAYS') },
    ],
    rangeLabel: t('FILTER_SELECT_RANGE'),
  },
  {
    field: ACTIVITY_FILTERS.module,
    label: t('FIELD_MODULE'),
    type: FilterTypes.checkbox,
    options: buildActivityModuleFilterOptions(t),
  },
];
